import { call, put, select } from "redux-saga/effects";
import api from "../../services/api";
import { Creators as CategoriasRecebimentosActions } from "../ducks/categoriasRecebimentos";
import { Creators as ModalActions } from "../ducks/modal";
import { Creators as AlertActions } from "../ducks/alert";
import { Creators as ErrorActions } from "../ducks/error";
import { Creators as SuccessActions } from "../ducks/success";
import { Creators as LoadingActions } from "../ducks/loading";
import { Creators as PageActions } from "../ducks/pages";

export function* getListCategoriasRecebimentos() {
  try {
    yield put(LoadingActions.setLoading());
    const { page, rowsPerPage, filter } = yield select(
      state => state.categoriasRecebimentos
    );
    const { data } = yield call(
      api.post,
      `/financial/categories/receipt/filter?page=${page +
        1}&&per_page=${rowsPerPage}`,
      filter
    );
    const { data: categoriasRecebimentos, total } = data;
    let categoriasRecebimentosPayload = [];
    categoriasRecebimentosPayload = categoriasRecebimentos.map(status => ({
      id: status.id,
      name: status.name,
      inactived: status.inactived
    }));
    const name = "Categorias de Recebimentos";
    const path = "categorias-de-recebimentos";
    yield put(PageActions.setPage(name, path));
    yield put(
      CategoriasRecebimentosActions.getListCategoriasRecebimentosSuccess(
        categoriasRecebimentosPayload,
        total
      )
    );
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getCategoriasRecebimentos({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    const { data } = yield call(
      api.get,
      `/financial/categories/receipt/${payload.id}`
    );
    yield put(
      CategoriasRecebimentosActions.getCategoriasRecebimentosSuccess(data)
    );
    const { action } = yield select(
      state => state.categoriasRecebimentosStores
    );
    if (action === "EDIT" || action === "DETAIL") {
      yield put(ModalActions.open());
    } else {
      const title = "Aviso de exclusão";
      const body = `O cadastro "${data.name}" será excluido do sistema.`;
      yield put(AlertActions.openAlert(title, body));
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* editCategoriasRecebimentos({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.put, `/financial/categories/receipt/${payload.id}`, payload);
    yield put(CategoriasRecebimentosActions.getListCategoriasRecebimentos());
    yield put(ModalActions.close());
    yield put(SuccessActions.openSuccess("Cadastro editado com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
    yield put(LoadingActions.unsetLoading());
  }
}

export function* addCategoriasRecebimentos({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/financial/categories/receipt`, payload);
    yield put(CategoriasRecebimentosActions.searchCategoriasRecebimentos({}));
    yield put(CategoriasRecebimentosActions.getListCategoriasRecebimentos());
    yield put(ModalActions.close());
    yield put(SuccessActions.openSuccess("Cadastro adicionado com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* deleteCategoriasRecebimentos() {
  try {
    yield put(LoadingActions.setLoading());
    const { id } = yield select(state => state.categoriasRecebimentos.item);
    yield call(api.delete, `/financial/categories/receipt/${id}`);
    yield put(CategoriasRecebimentosActions.getListCategoriasRecebimentos());
    yield put(SuccessActions.openSuccess("Cadastro excluído com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}

export function* searchCategoriasRecebimentos() {
  try {
    yield put(CategoriasRecebimentosActions.getListCategoriasRecebimentos());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* getListCategoriasRecebimentosSelects() {
  try {
    const { data: categoriasRecebimentos } = yield call(
      api.get,
      `/financial/categories/receipt/select`
    );
    yield put(
      CategoriasRecebimentosActions.getListCategoriasRecebimentosSuccessSelects(
        categoriasRecebimentos
      )
    );
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* deleteAllCategoriasRecebimentos({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/financial/categories/receipt/destroy-many`, {
      categories_id: payload.selected
    });
    yield put(CategoriasRecebimentosActions.getListCategoriasRecebimentos());
    yield put(SuccessActions.openSuccess("Cadastros excluídos com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/categoriasRecebimentos.js